module.exports = __webpack_public_path__ + "img/8.897a4f4.png";